<!--
 * @Description: 班组找活详情页
-->
<template>
  <div class="FlexibleDetail_page">
    <EmptyData :type="state" v-if="state != 1">
      当前数据已{{ state == 2 ? "下架" : "删除" }}，点击
      <a @click="handleBack">返回列表</a> 继续浏览吧~
    </EmptyData>
    <div
      class="leftBox"
      v-loading="loadingTrue"
      element-loading-background="rgba(255, 255, 255, 1)"
      v-if="state == 1"
    >
      <div class="item_top">
        <div class="title">
          <div class="name">
            <span
              class="state"
              v-if="Detail.employmentStatus"
              :style="
                Detail.employmentStatus === 1
                  ? { backgroundColor: '#e1251b' }
                  : ''
              "
            >
              {{ Detail.employmentStatusName }}
            </span>
            <span class="titleName">{{ Detail.name }}</span>
          </div>
        </div>
        <div class="detailBody">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-top: 20px">
                <span class="item_icon">
                  <img
                    style="width: 24px; height: 24px"
                    src="@/assets/TeamOfferDetail/zhgd.png"
                    alt=""
                  />
                </span>
                <span class="color6">工队：</span>
                <span class="color3">{{ Detail.teamName }}</span>
                <span
                  style="margin-left: 10px; color: #0286df; cursor: pointer"
                  @click="goTeamDetail(Detail)"
                  >查看</span
                >
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-top: 20px">
                <span class="item_icon">
                  <img
                    style="width: 24px; height: 24px"
                    src="@/assets/TeamOfferDetail/tdrs.png"
                    alt=""
                  />
                </span>
                <span class="color6">团队人数：</span>
                <span class="color3">{{Detail.teamSize && Detail.teamSize.toString().includes('人') ? Detail.teamSize  :  Detail.teamSize ? Detail.teamSize +'人' :  '/' }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-top: 20px">
                <span class="item_icon">
                  <img
                    style="width: 24px; height: 24px"
                    src="@/assets/TeamOfferDetail/gclx.png"
                    alt=""
                  />
                </span>
                <span class="color6">工程专业：</span>
                <span class="color3 single_hide" :title="Detail.categoryName">{{
                  Detail.categoryName|formattingEngineering
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img
                    style="width: 24px; height: 24px"
                    src="@/assets/TeamOfferDetail/szdq.png"
                    alt=""
                  />
                </span>
                <span class="color6">工作区域：</span>
                <span class="color3 single_hide" :title="Detail.serviceAreaName">{{ Detail.serviceAreaName|formattingServiceAreaName}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img
                    style="width: 24px; height: 24px"
                    src="@/assets/TeamOfferDetail/lxr.png"
                    alt=""
                  />
                </span>
                <span class="color6">联系人：</span>
                <span class="color3" v-if="Detail.contact">{{
                  Detail.contact|formatContactName
                }}</span>
                <span class="color3" v-else>/</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img
                    style="width: 24px; height: 24px"
                    src="@/assets/TeamOfferDetail/lxdh.png"
                    alt=""
                  />
                </span>
                <span class="color6">联系电话：</span>
                <span class="color3" v-if="showpNumber">{{ Detail.phoneNumber || "/" }}</span>
                <span class="color3" v-else>{{ ShowPhone(Detail.phoneNumber) }}</span>
                <span style="color:#0286DF;cursor: pointer;line-height:25px;margin-left:10px" v-if="!showpNumber" @click="ShowPhoneNumber">查看</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="Detail.profile">
            <el-col :span="24">
              <div class="item_texts single_hide" style="padding-bottom: 0">
                <span class="item_icon">
                  <img
                    style="width: 24px; height: 24px"
                    src="@/assets/TeamOfferDetail/gdjs.png"
                    alt=""
                  />
                </span>
                <span class="color6" style="margin-top:3px">工队介绍：</span> 
                <p class="color3" style="display:inline-block;white-space: normal;word-wrap:break-word;word-break: break-all;margin-top:3px">{{ Detail.profile }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div>
          <btns
            :item="Detail"
            :type="7"
            @end="getDetail"
            @changeStatus="v => (state = v)"
          ></btns>
        </div>
        <!-- <div style="padding: 0 20px">
          <div class="little-tips">
            <img
              style="width: 18px; height: 18px; margin-right: 8px"
              src="@/assets/TeamOfferDetail/ts.png"
              alt=""
            />
            <span
              >温馨提示:此信息由经营帮用户发布，联系时需注意识别信息真假，<span
                style="color: #0286df"
                >防骗指南</span
              >。如发现虚假信息，请<span style="color: #0286df">立即举报</span
              >。</span
            >
          </div>
        </div> -->
      </div>
      <!-- 推荐列表 -->
      <div class="recommendList">
        <div class="title">
          <div class="name">相关工队找活推荐</div>
          <div
            class="more"
            @click="goTeamList"
          >
            查看更多
            <img src="@/assets/teamIcon/more.png" alt="" />
          </div>
        </div>

        <div v-loading="loadingTrue">
          <el-row
            style="padding: 0px 20px 20px"
            :gutter="20"
            v-if="recommendedList.length"
          >
            <el-col
              v-for="(item, index) in recommendedList"
              :span="12"
              :key="index"
            >
              <card :item="item" :type="7"></card>
            </el-col>
          </el-row>
        </div>
        <BaseEmptyData
          isDetail
          v-if="!recommendedList.length && !loadingTrue"
        ></BaseEmptyData>
      </div>
    </div>
  </div>
</template>

<script>
import { apiTeamSearchJob } from "@/api/apiTeamSearchJob"
import cookie from "@/storage/cookies"
export default {
  name: "TeamSearchJobDetail",
  inject: ["reload"], // 引入App.vue 中的刷新页面的方法
  data() {
    return {
      showTooltip: false,
      showpNumber: false,
      state: 1, // 数据状态：1 正常；2 下架； 3 删除
      loadingTrue: false,
      Detail: {},
      recommendedList: []
    }
  },
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    InByLetDialog: () => import("@/components/public/InquiryLetterDialog"), // 函询弹框
    btns: () => import("@/components/details/btns"), // 按钮组
    Pagination: () => import("@/views/Construction/components/Pagination"), // 分页
    EmptyData: () => import("@/components/public/UI/EmptyData"), // 数据被删除/下架显示的缺省图
    card: () => import("@/components/card/cardTeamSearchJob.vue") // 工队找活card
  },
  created() {
    if (this.$route.query) {
      this.getDetail(this.$route.query.no)
    }
  },
  methods: {
    // 联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },
    //  查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    // 点击查看跳转工队详情
    async goTeamDetail(detail) {
        let routeUrlC = `${"/ConstructionTeamDetail"}?userNo=${
          detail.userNo
        }&teamNo=${detail.teamNo}&companyNo=${detail.companyNo}`
        window.open(routeUrlC, "_blank")
    },
    async getDetail(no) {
      this.loadingTrue = true
      let res = await apiTeamSearchJob.GetTeamsearchjobDetail(no)
      this.Detail = res.data.data
      //处理工队名称隐藏
      let arr=this.Detail.teamName.split('-')
      if(arr[0].length > 2){
        arr[0]=arr[0].substr(0, 1) + '*'+ arr[0].substr(-1)
      }else{
        arr[0]=arr[0].substr(0, 1) + '*'
      }
      this.Detail.teamName=arr.join('-')
      this.loadingTrue = false
      this.getRecommendedList()
    },
    handleBack() {
      const referrer = document.referrer
      if (referrer.includes("TeamSearchJobDetail")) {
        this.$router.replace("/teamList")
      } else {
        window.location.href = referrer
      }
    },
    //点推荐列表的查看更多跳转到班组找活列表页
    goTeamList(){
      this.$router.push({
        path: "/teamList",
        query: {name:'班组找活'}
      })
    },
    //获取推荐列表
    async getRecommendedList() {
      this.loadingTrue = true
      const params = {}
      let area = JSON.parse(cookie.cookieRead("area"))
      params.provinceNo = area.id //省份
      params.thirdCategoryNo = this.Detail.thirdCategoryNo
      params.no = this.Detail.no
      const res = await apiTeamSearchJob.GetTeamsearchjobRecommend(params)
      if (res.data.code === 200) {
        this.recommendedList = res.data.data.slice(0, 6)
      } else {
        this.$message.error("系统异常，请稍后再试")
        this.recommendedList = []
      }
      this.loadingTrue = false
    },
    getList() {
      this.getRecommendedList()
    }
  },
  provide() {
    return {
      cardListCom: this
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
div {
  box-sizing: border-box;
}
.color6 {
  color: #666666;
}
.color3 {
  color: #333333;
}
.single_hide {
  // 单行隐藏
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.FlexibleDetail_page {
  padding: 10px 0 0 0;
  width: 1200px;
  font-size: 16px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .leftBox {
    width: 1200px;
    .item_top {
      background-color: #fff;
      border: 1px solid #e4e7ed;
      .title {
        text-align: center;
        padding-top: 20px;
        position: relative;
        .name {
          display: flex;
          align-items: center;
          justify-content: center;
          .state {
            width: 51px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            display: inline-block;
            background-color: #409ee9;
            color: #ffffff;
            font-size: 12px;
          }
          .titleName {
            margin-left: 10px;
            font-size: 18px;
            color: #333333;
          }
        }
      }
      .detailBody {
        padding-left: 20px;
        padding-right: 20px;
        .item_text {
          font-size: 14px;
          width: 100%;
          font-weight: 400;
          color: #666666;
          display: flex;
          align-items: center;
          padding-top: 20px;
          .item_icon {
            width: 24px;
            height: 24px;
            padding-right: 10px;
          }
        }
        .item_texts {
          font-size: 14px;
          width: 100%;
          font-weight: 400;
          color: #666666;
          display: flex;
          // align-items: center;
          padding-top: 20px;
          .item_icon {
            width: 24px;
            height: 24px;
            padding-right: 10px;
          }
        }
      }
      .little-tips {
        border-top: 1px dashed #e4e7ed;
        padding-top: 10px;
        margin-bottom: 10px;
        color: #666666;
        font-size: 14px;
        display: flex;
        align-items: center;
      }
      .tips {
        color: #969696;
        font-size: 14px;
      }
    }
  }
}
.recommendList {
  margin-top: 10px;
  background-color: #ffffff;
  border: 1px solid #e4e7ed;
  .title {
    font-weight: normal !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0;
    height: 40px;
    border-bottom: 1px solid #e4e7ed;
    .name {
      color: #b79255;
      font-size: 18px;
      height: 20px;
      padding-left: 10px;
      border-left: 3px solid #b79255;
      line-height: 20px;
    }
    .more {
      cursor: pointer;
      font-size: 14px;
      color: #666666;
      display: flex;
      align-items: center;
      img {
        margin-left: 5px;
        width: 16px;
        height: 16px;
      }
    }
  }
  /deep/ .empty-data .nodata .message {
    line-height: 1;
  }
}
</style>
<style lang="scss">
.item_top {
  .el-button--primary {
    color: #fff;
    background-color: #b79255;
    border-color: #b79255;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.popperCustoms {
  padding: 5px 10px !important;
  &.is-light {
    background: #ffffff !important;
    border: 1px solid #666666;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0;
    opacity: 1 !important;
    color: #666666 !important;
  }
}
</style>